// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hive_l1timdo5{width:64px;height:64px;background:white;border-radius:50%;border:2px solid white;overflow:hidden;box-shadow:0 2px 8px rgba(0,0,0,0.15);position:absolute;bottom:100%;left:50%;-webkit-transform:translateX(-50%) translateY(50%);-ms-transform:translateX(-50%) translateY(50%);transform:translateX(-50%) translateY(50%);z-index:1;}\n.hive_i1b5hz4j{width:100%;height:100%;}\n", ""]);
// Exports
module.exports = exports;
